<template>
    <div class="body-panel">
        <template v-if="folder != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back margin-right-10">
                            <a class="router-link-active" href="" @click.prevent="back">Назад</a>
                        </p>
                        <p class="caption-help margin-right-10" v-if="folder.new">Добавление папки</p>
                        <p class="caption-help" v-if="!folder.new">Редактирование папки #{{ folder.Id }}</p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex">
                        <template v-if="folder.DateArchive == null && !folder.new">
                            <button type="button" class="btn btn-primary" @click="archiveFolder(true)" :disabled="savingInProgress">Архивировать все</button>
                            <button type="button" class="btn btn-primary" @click="archiveFolder(false)" :disabled="savingInProgress">Архивировать папку</button>
                        </template>
                        <template v-else-if="!folder.new">
                            <button type="button" class="btn btn-primary" @click="openSelectFolderModal(true)" :disabled="savingInProgress">Восстановить все</button>
                            <button type="button" class="btn btn-primary" @click="openSelectFolderModal(false)" :disabled="savingInProgress">Восстановить папку</button>
                        </template>
                        <button type="button" class="btn btn-primary" @click="saveFolder()" :disabled="savingInProgress">Сохранить</button>
                        <button type="button" class="btn btn-delete" @click="deleteFolder">Удалить</button>
                    </div>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page">
                <div class="body-panel page-content-block">
                    <form class="form-horizontal" novalidate="novalidate" ref="myForm" method="post" enctype="multipart/form-data">

                        <div class="block-in-page">
                            <div class="form-field">
                                <label class="input-text-lbl">
                                    Название папки
                                    <span class="required" aria-required="true">*</span>
                                </label>
                                <input name="Name" :class="['input-text', {'input-error': errors.has('Name')}]" type="text" v-validate="'required'" v-model="folder.Name">
                                <span class="field-validation-valid">{{ errors.first('Name') }}</span>
                            </div>
                        </div>

                        <div class="block-in-page">
                            <div class="flex">
                                <image-setting :img="imgSite" :name="'site'" :parentImage="true" @onImageViewChanged="onImageViewChanged"></image-setting>
                                <div class="form-field" style="width:300px;min-width:300px;margin-left:20px">
                                    <div class="panel-block panel-block-new" style="margin-right:0">
                                        <div class="panel-block-img-base">
                                            <div class="panel-block-img">
                                                <img :src="imgSitePath" alt="" :style="imageStyleFormatted" v-if="imgSitePath" />
                                            </div>
                                        </div>
                                        <div class="panel-block-info">
                                            <p class="panel-block-header margin-bottom-10">{{ folder.Name }}</p>
                                        </div>
                                        <div class="panel-body-actions">
                                            <button class="btn">Просмотр</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="block-in-page">
                            <div class="flex">
                                <image-setting :img="imgMobile" :parentImgPath="imgSitePath" :name="'mobile'" @onImageViewChanged="onImageViewChanged"></image-setting>
                                <div class="form-field" style="width:400px;min-width:400px;margin-left:20px">
                                    <div class="panel-block panel-block-new panel-block-mobile" style="margin-right:0">
                                        <div class="panel-block-img-base panel-block-img-mobile-folder">
                                            <div class="panel-block-img panel-block-img-mobile-folder">
                                                <img :src="imgMobilePath" alt="" :style="imageStyleMobileFormatted" v-if="imgMobilePath" />
                                            </div>
                                            <div class="panel-block-info">
                                                <p class="panel-block-header margin-bottom-10">{{ folder.Name }}</p>
                                            </div>
                                        </div>
                                        <div class="panel-body-actions">
                                            <button class="btn">Просмотр</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </template>

        <popup-window ref="ppFolderList" :title="'Восстановление в папку'" :width="600">
            <p class="caption-help"></p>
            <div :key="componentKey">
                <div v-for="(item, i) of folders" :class="['list-select-text', {'active':item.Checked}]" @click="onSelectFolder(item, i, $event)">
                    <label class="input-text-lbl">{{ item.Name }}</label>
                </div>
            </div>

            <button type="button" class="btn btn-primary margin-top-10" @click="restoreFolder()">Выбрать</button>
        </popup-window>

        <vue-headful title="Папки материалов" />
    </div>
</template>

<script>
    import BackendApi from '../../backendApi'
    import $ from 'jquery'
    import UI from '../../helpers/ui-helpers'
    import moment from 'moment'

    let backendApi = new BackendApi();

    let ImageStyleDefault = {
        top: 0,
        left: 100,
        translateY: 0,
        translateX: -50,
        size: 100,
        resizeType: 1
    };

    export default {
        name: "folder-edit",
        data() {
            return {
                folder: null,
                file: null,
                deleteImage: false,
                folders: [],
                imgSitePath: null,
                imgSite: {},
                imgMobilePath: null,
                imgMobile: {},
                savingInProgress: false,
                componentKey: 0,
            }
        },

        computed:{
            imageStyleFormatted(){
                let settings = {
                    left: this.imgSite.ImageStyle.left + '%',
                    top: this.imgSite.ImageStyle.top + '%',
                    transform: 'translateY(' + this.imgSite.ImageStyle.translateY + '%) translateX(' +
                        this.imgSite.ImageStyle.translateX + '%)'
                };
                if (this.imgSite.ImageStyle.resizeType === 1 && parseInt(this.imgSite.ImageStyle.size)){
                    settings.height = this.imgSite.ImageStyle.size + '%';
                }
                if (this.imgSite.ImageStyle.resizeType === 2 && parseInt(this.imgSite.ImageStyle.size)){
                    settings.width = this.imgSite.ImageStyle.size + '%';
                }

                return settings;
            },

            imageStyleMobileFormatted() {
                let settings = {
                    left: this.imgMobile.ImageStyle.left + '%',
                    top: this.imgMobile.ImageStyle.top + '%',
                    transform: 'translateY(' + this.imgMobile.ImageStyle.translateY + '%) translateX(' +
                        this.imgMobile.ImageStyle.translateX + '%)'
                };
                if (this.imgMobile.ImageStyle.resizeType === 1 && parseInt(this.imgMobile.ImageStyle.size)) {
                    settings.height = this.imgMobile.ImageStyle.size + '%';
                }
                if (this.imgMobile.ImageStyle.resizeType === 2 && parseInt(this.imgMobile.ImageStyle.size)) {
                    settings.width = this.imgMobile.ImageStyle.size + '%';
                }

                return settings;
            },
        },

        methods: {
            back() {
                this.$router.back();
            },

            onSelectFolder(item) {
                let vm = this;
                vm.parentId = item.Id;
                for(let i = 0; i < vm.folders.length; i++) {
                    if(vm.folders[i].Checked) {
                        vm.folders[i].Checked = false;
                    }
                }
                item.Checked = true;
                vm.componentKey++;
            },

            archiveFolder(full) {
                let vm = this;
                let messConfirm = full ? 'Вы уверены? Подпапки также станут архивными.' : 'Вы уверены? Подпапки останутся активными.';
                if(confirm(messConfirm)) {
                    UI.blockUI('.portlet', 'Консервация...');
                    let saveObj = {Id: vm.folder.Id, Full: full};
                    backendApi.folderArchive(saveObj).then(function (response) {
                        UI.unblockUI('.portlet');
                        if(response.hasError) {
                            UI.toastr.error('Ошибка при архивации');
                        } else {
                            UI.toastr.success('Успешно архивировано');

                            vm.$router.back();
                        }
                    });
                }
            },

            openSelectFolderModal(full) {
                let vm = this;
                vm.fullRestore = full;
                vm.$refs.ppFolderList.show();
            },

            restoreFolder() {
                let vm = this;
                UI.blockUI('.portlet', 'Восстановление...');
                let saveObj = {Id: vm.folder.Id, Full: vm.fullRestore, ParentId: vm.parentId};
                backendApi.folderRestore(saveObj).then(function (response) {
                    UI.unblockUI('.portlet');
                    if(response.hasError) {
                        UI.toastr.error('Ошибка при восстановлении');
                    } else {
                        UI.toastr.success('Успешно восстановлено');
                        vm.folder.DateArchive = null;
                        vm.$refs.ppFolderList.close();
                    }
                });
            },

            loadFolders(){
                let vm = this;

                let projectId = vm.folder.new ? 0 : vm.folder.ProjectId;
                //alert(projectId)
                return backendApi.folderList(projectId).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке папок материалов');
                    }
                    else {
                        vm.folders = [{Id: null,Name: 'Корневая'}];
                        vm.folders.push(...response.data);
                    }
                });
            },

            loadFolder() {
                let vm = this;
                let id = parseInt(vm.$route.params.id);
                if (id === 0) {
                    let parentId = vm.$route.query.folderId;

                    this.folder = {
                        new: true,
                        ImageStyle: JSON.parse(JSON.stringify(ImageStyleDefault)),
                        ParentId: parentId,
                        ImageStyleMobile: JSON.parse(JSON.stringify(ImageStyleDefault)),
                        ImageMobile: {}
                    };
                    vm.imgSite = {
                        ImageStyle: vm.folder.ImageStyle,
                        ImagePath: null,
                        Image: {}
                    };
                    vm.imgMobile = {
                        ImageStyle: vm.folder.ImageStyleMobile,
                        ImagePath: null,
                        Image: {}
                    };

                    return new Promise(resolve => resolve());
                }
                else {
                    return backendApi.folderLoad(id).then(function (response) {
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при загрузке папки');
                        }
                        else {
                            if (response.data == null) {
                                vm.$router.back();
                            }

                            if (response.data.ImageStyle) {
                                response.data.ImageStyle = JSON.parse(response.data.ImageStyle);
                            } else {
                                response.data.ImageStyle = JSON.parse(JSON.stringify(ImageStyleDefault));
                            }
                            if (response.data.ImageStyleMobile) {
                                response.data.ImageStyleMobile = JSON.parse(response.data.ImageStyleMobile);
                            } else {
                                response.data.ImageStyleMobile = JSON.parse(JSON.stringify(ImageStyleDefault));
                            }

                            response.data.FileData = null;

                            vm.folder = response.data;
                            vm.folder.ImageMobile = {};
                            vm.imgMobile = {
                                ImageStyle: vm.folder.ImageStyleMobile,
                                ImagePath: vm.folder.ImageMobilePath,
                                Image: {}
                            };
                            vm.imgSite = {
                                ImageStyle: vm.folder.ImageStyle,
                                ImagePath: vm.folder.Image,
                                Image: {}
                            };
                        }
                    })
                }
            },

            saveFolder() {
                let vm = this;

                this.$validator.validate().then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        if (vm.savingInProgress) {
                            return;
                        }
                        vm.savingInProgress = true;
                        UI.blockUI('.portlet', 'Сохранение...');
                        let selectedProjectId = localStorage.getItem('selectedProjectId');

                        let saveObj = Object.assign({}, vm.folder, {
                            ProjectId: selectedProjectId != null ? parseInt(selectedProjectId) : null,
                            DeleteImage: vm.imgSite.Image.Id === -1//vm.deleteImage
                        });
                        saveObj.ImageStyle = JSON.stringify(vm.imgSite.ImageStyle);
                        saveObj.FileData = vm.imgSite.Image.FileData;
                        saveObj.FileName = vm.imgSite.Image.FileName;
                        saveObj.ImageMobile = vm.imgMobile.Image;
                        if (vm.imgMobile.ImageStyle.useMainPhoto) {
                            saveObj.ImageMobile.FileName = '';
                            saveObj.ImageMobile.FileData = '';
                            saveObj.ImageMobile.Id = -1;
                            saveObj.ImageMobilePath = '';
                        }
                        saveObj.ImageStyleMobile = JSON.stringify(vm.imgMobile.ImageStyle);

                        backendApi.folderSave(saveObj).then(function (response) {
                            //console.info('response.data', response.data)
                            UI.unblockUI('.portlet');
                            if (response.hasError) {
                                UI.toastr.error('Ошибка при сохранении папки');
                            } else {
                                UI.toastr.success('Успешно сохранено');

                                vm.$router.back();
                                //vm.$router.push('/materials?folderId=' + response.data.Id);
                            }
                            vm.savingInProgress = false;
                        });
                    }
                });
            },

            deleteFolder(){
                let that = this;

                if (confirm('Вы уверены? Подпапки и связанные материалы будут также удалены.')) {
                    UI.blockUI('.portlet', 'Удаление...');
                    backendApi.folderDelete(that.folder.Id).then(function (response) {
                        UI.unblockUI('.portlet');
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при удалении папки');
                        } else {
                            UI.toastr.success('Успешно удалено');
                            that.$router.push('/materials');
                        }
                    });
                }
            },

            onImageViewChanged(imgPath, name) {
                if (name === 'site')
                    this.imgSitePath = imgPath;
                else
                    this.imgMobilePath = imgPath;
            }
        },


        mounted() {
            let vm = this;

            UI.blockUI('.page-content', 'Загрузка...');
            vm.loadFolder().then(() => vm.loadFolders().then(() => {
                UI.unblockUI('.page-content');

            }));
        },

        destroyed(){
            
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// Content/src/views/edit/FolderEdit.vue